var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.475C11.8667 15.475 11.7377 15.45 11.613 15.4C11.4877 15.35 11.3834 15.2834 11.3 15.2L6.70005 10.6C6.51672 10.4167 6.42505 10.1834 6.42505 9.90005C6.42505 9.61671 6.51672 9.38338 6.70005 9.20005C6.88338 9.01672 7.11672 8.92505 7.40005 8.92505C7.68338 8.92505 7.91672 9.01672 8.10005 9.20005L12 13.1L15.9 9.20005C16.0834 9.01672 16.3167 8.92505 16.6 8.92505C16.8834 8.92505 17.1167 9.01672 17.3 9.20005C17.4834 9.38338 17.575 9.61671 17.575 9.90005C17.575 10.1834 17.4834 10.4167 17.3 10.6L12.7 15.2C12.6 15.3 12.4917 15.3707 12.375 15.412C12.2584 15.454 12.1334 15.475 12 15.475Z",
    fill: "#516EE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.444877a70c639c0edf2f6f289656fce7.svg";
export { ForwardRef as ReactComponent };